<template>
  <div v-if="actions && actions.length > 0" class="suggested-actions">
    <div class="actions-header">
      <span class="actions-label">Suggested actions:</span>
    </div>
    <div class="actions-grid">
      <button
        v-for="(action, index) in actions"
        :key="index"
        @click="handleActionClick(action)"
        class="action-button"
        :class="[`action-${action.action_type}`]"
      >
        <!-- <span class="action-icon">
          <svg v-if="action.action_type === 'get_event_info'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          <svg v-else-if="action.action_type === 'search_attendees'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
          <svg v-else-if="action.action_type === 'get_venue_map'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"></polygon>
            <line x1="9" y1="3" x2="9" y2="18"></line>
            <line x1="15" y1="6" x2="15" y2="21"></line>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 11H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h4"></path>
            <path d="M9 21V9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12"></path>
            <path d="M21 21h-8"></path>
            <path d="M17 8v3"></path>
          </svg>
        </span> -->
        {{ action.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuggestedActions',
  props: {
    actions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['action-click'],
  methods: {
    handleActionClick(action) {
      this.$emit('action-click', action);
    }
  }
};
</script>

<style scoped>
.suggested-actions {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.actions-header {
  margin-bottom: 8px;
}

.actions-label {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.actions-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.action-button {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 16px;
  font-size: 0.85rem;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  font-weight: 500;
  line-height: 1.2;
}

.action-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #212529;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.action-icon {
  margin-right: 6px;
  display: flex;
  align-items: center;
  opacity: 0.8;
}

/* Action type specific styling */
.action-get_event_info {
  color: #0d6efd;
  border-color: #b6d4fe;
}

.action-get_event_info:hover {
  background-color: #cfe2ff;
  border-color: #9ec5fe;
  color: #084298;
}

.action-search_attendees {
  color: #198754;
  border-color: #b8dfcb;
}

.action-search_attendees:hover {
  background-color: #d1e7dd;
  border-color: #a3cfbb;
  color: #0f5132;
}

.action-get_venue_map {
  color: #fd7e14;
  border-color: #ffda6a;
}

.action-get_venue_map:hover {
  background-color: #fff3cd;
  border-color: #ffcd39;
  color: #843b0b;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .action-button {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
  
  .actions-grid {
    gap: 4px;
  }
}
</style>